import React from 'react';
import Header from '../Header/Header';

const Faq = () => {
    return (
        <div>
            <Header></Header>
            <div className='container'>
                <h3>FAQ page</h3>
            </div>
        </div>
    );
};

export default Faq;